<template>
  <div class="h-full p-[5px] relative pl-[0px] pb-[24px] pt-[10px] flex-grow overflow-hidden">
    <div
      v-if="!layoutStore.showResults"
      class="flex justify-center items-center flex-col h-full w-full"
    >
      <div>
        <p class="greet">{{ greetTextRaw }}</p>
        <p class="greet-sub">{{ greetSubTextRaw }}</p>
      </div>
    </div>
    <Result class="result-wrapper" v-if="layoutStore.showResults" />
  </div>
</template>

<script setup>
import { useLayoutStore } from '../store/layoutStore'

import { ref } from 'vue'
const layoutStore = useLayoutStore()
const greetTextRaw = ref('Hi! 你好!')
const greetSubTextRaw = ref('今天需要我做些什么？')
</script>

<style lang="scss" scoped>
.rotate-180 {
  transform: translate(0px, -14px) rotate(180deg);
}
.greet {
  color: transparent;
  -webkit-text-fill-color: rgba(255, 255, 255, 0.4);
  background-clip: text;
  color: transparent;
  background-image: linear-gradient(
    74deg,
    rgb(66, 133, 244) 0px,
    rgb(155, 114, 203) 9%,
    rgb(217, 101, 112) 20%,
    rgb(217, 101, 112) 24%,
    rgb(155, 114, 203) 35%,
    rgb(66, 133, 244) 44%,
    rgb(155, 114, 203) 50%,
    rgb(217, 101, 112) 56%,
    rgb(255, 255, 255) 75%,
    rgb(255, 255, 255) 100%
  );
  background-attachment: scroll;
  background-clip: text;
  background-color: rgba(0, 0, 0, 0);
  font-size: 32px;
  background-size: 400% 100%;
  -webkit-text-fill-color: rgba(0, 0, 0, 0);
  font-weight: 500;
}

.greet-sub {
  font-size: 32px;
  font-weight: 400;
  color: #ccc;
}

.result-wrapper {
  height: 100%;
}
.hide_task_list {
  svg {
    fill: #c8cad9;
  }
}
</style>
